import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { FormScan, ScanAndUploadFormsResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export interface ScanAndUploadFormsInput {
	formScans: FormScan[];
}

export const scanAndUploadForms = async (
	servicesProviderId: string,
	orderId: string,
	data: ScanAndUploadFormsInput,
): Promise<ScanAndUploadFormsResponse> => {
	const response = await apiClient.post<ScanAndUploadFormsResponse>(
		ordersEndpoints.scanAndUploadForms(servicesProviderId, orderId),
		data,
	);
	return response.data;
};

export const useScanAndUploadForms = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (input: ScanAndUploadFormsInput) => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to scan and upload forms without an order ID or services provider ID.',
				);
			}

			return scanAndUploadForms(servicesProviderId, orderId, input);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.SCAN_AND_UPLOAD_FORMS);
		},
	});
};
